import api from '../api';

/**
 * Fetch the permission of a user based on their userId.
 *
 * @param {string} phone - The ID of the user.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getPermission = async (phone) => {
  if (!phone) {
    throw new Error('Phone number is required.');
  }

  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/user/getPermission?phone=${encodeURIComponent(phone)}`;
  try {
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching user permission:', error);
    throw error;
  }
}

export default getPermission;
